import {useTranslation} from 'react-i18next';
import {ButtonProps} from 'components/common/Button';
import {ButtonConfirm, Text, Wrapper, BodyImage, StyledLottie} from './styled';
import {cn} from '@chekin/guestapp-ui-kit';

export type StandardModalSheetProps = {
  text?: string | JSX.Element | JSX.Element[];
  buttons?: ButtonProps[];
  img?: string;
  lottie?: object | null;
  className?: string;
  content?: JSX.Element | JSX.Element[];
};
function StandardModalSheet({
  text,
  img,
  lottie,
  buttons,
  className,
  content,
}: Readonly<StandardModalSheetProps>) {
  const {t} = useTranslation();

  return (
    <Wrapper className={cn(className, 'standard-modal-sheet', 'kiosko:mt-8')}>
      {text && (
        <Text className="standard-modal-sheet__text kiosko:text-kiosko-m kiosko:mb-[114px]">
          {text}
        </Text>
      )}
      {content && content}
      {img && <BodyImage className="standard-modal-sheet__image" src={img} />}
      {lottie && <StyledLottie animationData={lottie} />}
      {buttons
        ? buttons.map((buttonProps, index) => {
            const label =
              typeof buttonProps.label === 'string'
                ? t(buttonProps?.label as string)
                : buttonProps.label;

            return (
              <ButtonConfirm
                className={cn(
                  'standard-modal-sheet__button',
                  'kiosko:h-[114px] kiosko:rounded-[56px] kiosko:text-kiosko-m kiosko:w-[698px] kiosko:max-w-none kiosko:mb-[56px]',
                )}
                {...buttonProps}
                label={label}
                key={index}
              />
            );
          })
        : null}
    </Wrapper>
  );
}

export {StandardModalSheet};
